import Vue from 'vue';

export const downloadBlobMixin = function downloadBlobMixin() {
  Vue.mixin({
    methods: {
      $downloadBlob(blob, fileName) {
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, fileName);
          return;
        }

        const data = window.URL.createObjectURL(blob);

        this.$openLink(data, fileName);
      },
    },
  });
};

export const openLinkMixin = function openLinkMixin() {
  Vue.mixin({
    methods: {
      $openLink(href, fileName) {
        const link = document.createElement('a');
        link.href = href;

        if (fileName) {
          link.download = fileName;
        } else {
          link.target = '_blank';
        }

        document.body.appendChild(link);

        link.click();

        // Give firefox some time to handle click
        // put methods call to the end of the call stack
        setTimeout(() => {
          link.remove();
          window.URL.revokeObjectURL(href);
        }, 0);
      },
    },
  });
};
